import axios from "axios"

export default {
	user: null,

	getMySectionsTeacher() {
		return axios.get(`/v1/my_sections/teacher`)
	},

	getMySectionsMember() {
		return axios.get(`/v1/my_sections/member`)
	},

	getContextPrefilled() {
		return axios.get(`/v1/context/prefilled`)
	},

	getSectionPrefilled(sectionID) {
		return axios.get(`/v1/section/prefilled/${sectionID}`)
	},

	saveSection(section) {
		return axios.post(`/v1/section`, section)
	},

	searchUsers(ctx, role, filter) {
		ctx.query = { role: role }
		ctx.filter = filter
		return axios.post(`/v1/search_users`, ctx)
	},

	addTeacher(teacherID) {
		return axios.post(`/v1/context/teacher/${teacherID}`)
	},

	removeTeacher(teacherID) {
		return axios.delete(`/v1/context/teacher/${teacherID}`)
	},

	addStudent(studentID) {
		return axios.post(`/v1/context/student/${studentID}`)
	},

	removeStudent(studentID) {
		return axios.delete(`/v1/context/student/${studentID}`)
	},

	addPartner(partnerID) {
		return axios.post(`/v1/context/partner/${partnerID}`)
	},

	removePartner(partnerID) {
		return axios.delete(`/v1/context/partner/${partnerID}`)
	},

	addJudge(judgeID) {
		return axios.post(`/v1/context/judge/${judgeID}`)
	},

	removeJudge(judgeID) {
		return axios.delete(`/v1/context/judge/${judgeID}`)
	},

	regenerateStudentCode(sectionID) {
		return axios.post(`/v1/section/${sectionID}/regen_code/student`)
	},

	regeneratePartnerCode(sectionID) {
		return axios.post(`/v1/section/${sectionID}/regen_code/partner`)
	},

	regenerateJudgeCode(sectionID) {
		return axios.post(`/v1/section/${sectionID}/regen_code/judge`)
	},

	regenerateContextStudentCode() {
		return axios.post(`/v1/context/regen_code/student`)
	},

	regenerateContextPartnerCode() {
		return axios.post(`/v1/context/regen_code/partner`)
	},

	regenerateContextJudgeCode() {
		return axios.post(`/v1/context/regen_code/judge`)
	},

	contextInviteUser(email, role, template) {
		let ctx = {
			email: email,
			role: role,
			template: template,
		}

		return axios.post(`/v1/context/invite_user`, ctx)
	},

	getContextSubmissions() {
		return axios.get(`/v1/context/submissions`)
	},

	submitPortfolio(sectionID, studentID) {
		return axios.post(`/v1/submission/${sectionID}/${studentID}`)
	},

	unsubmitPortfolio(sectionID, studentID) {
		return axios.delete(`/v1/submission/${sectionID}/${studentID}`)
	},
}